import { useEffect, useState } from "react";

export const useMyScripts = () => {
  const [myscripts, setMyscripts] = useState(null);
    
    useEffect(() => {
        if (!myscripts) {
            const head = document.head;
            let script = document.getElementById('Materialize');
            if (script){                
                setMyscripts(window.M);
                //console.log(myscripts);
            }
        }
   }, [myscripts]);

   const getMyscripts = () => {
        return myscripts;
   }

  return getMyscripts();
}

export const useToast = () => {
    let mat = useMyScripts();
    
    const toast = (msg) => {
        mat.toast({html: msg});
    }

    const toastSuccess = (msg) => {
        mat.toast({html: msg, classes:'green-information'});
    };

    const toastError = (msg) => {
        mat.toast({html: msg, classes:'red-information'});
    };

    const toastInformation = (msg) => {
        mat.toast({html: msg, classes:'yellow-information'});
    }

    return {
        toast,
        toastSuccess,
        toastError,
        toastInformation,
    }
}

export const useModal = () => {
    let mat = useMyScripts();
    const init = () => {
        mat.Modal(document.querySelectorAll(".modal"));
    };

    return {init};
}


